import { useLanguage } from "../context/LanguageContext"
import { SkillSection } from "./SkillSection";

export const Skills = () => {


    const { t } = useLanguage();

    return (
        <div className="skills" id="skills">

            <h1>{t.skills.skillsTitle}</h1>


            <SkillSection title={t.skills.languajes}>
                <div className="skills-container">

                    <div className="skill"><i className="devicon-kotlin-plain colored" /><span>Kotlin</span></div>
                    <div className="skill"><i className="devicon-java-plain colored" /><span>Java</span></div>
                    <div className="skill"><i className="devicon-python-plain colored" /><span>Python</span></div>
                    <div className="skill"><i className="devicon-csharp-plain colored" /><span>C#</span></div>
                    <div className="skill"><i className="devicon-dart-plain colored" /><span>Dart</span></div>
                    <div className="skill"><i className="devicon-javascript-plain colored" /><span>JavaScript</span></div>
                    <div className="skill"><i className="devicon-typescript-plain colored" /><span>TypeScript</span></div>

                </div>
            </SkillSection>

            <SkillSection title={t.skills.frameworks}>
                <div className="skills-container">

                    <div className="skill"><i className="devicon-jetpackcompose-plain colored"></i><span>Jetpack compose</span></div>
                    <div className="skill"><i className="devicon-flutter-plain colored"></i><span>Flutter</span></div>
                    <div className="skill"><i className="devicon-react-original colored"></i><span>React</span></div>
                    <div className="skill"><i className="devicon-qt-plain colored"></i><span>QT</span></div>
                    <div className="skill"><i className="devicon-spring-plain colored"></i><span>Spring boot</span></div>
                    <div className="skill"><i className="devicon-dotnetcore-plain colored"></i><span>.NET</span></div>

                </div>
            </SkillSection>
            
            <SkillSection title={t.skills.databases}>
                <div className="skills-container">

                    <div className="skill"><i className="devicon-mongodb-plain colored"></i><span>MongoDB</span></div>
                    <div className="skill"><i className="devicon-mysql-plain colored"></i><span>MySQL</span></div>
                    <div className="skill"><i className="devicon-postgresql-plain colored"></i><span>PostgreSQL</span></div>
                    <div className="skill"><i className="devicon-firebase-plain colored"></i><span>Firebase</span></div>

                </div>
            </SkillSection>
            
            <SkillSection title={t.skills.tools}>
                <div className="skills-container">

                    <div className="skill"><i className="devicon-render-original colored"></i><span>Render</span></div>
                    <div className="skill"><i className="devicon-docker-plain colored"></i><span>Docker</span></div>
                    <div className="skill"><i className="devicon-insomnia-plain colored"></i><span>Insomnia</span></div>
                    
                </div>
            </SkillSection>

            <SkillSection title={t.skills.IDES}>
                <div className="skills-container">

                    <div className="skill"><i className="devicon-androidstudio-plain colored"></i><span>Android Studiuo</span></div>
                    <div className="skill"><i className="devicon-visualstudio-plain colored"></i><span>Visual Studio</span></div>
                    <div className="skill"><i className="devicon-intellij-plain colored"></i><span>IntelliJ</span></div>
                    
                </div>
            </SkillSection>

            <SkillSection title={t.skills.versionContol}>
                <div className="skills-container">

                    <div className="skill"><i className="devicon-git-plain colored"></i><span>Git</span></div>
                    <div className="skill"><i className="devicon-github-original colored"></i><span>Github</span></div>

                </div>
            </SkillSection>
        </div>
    )

}